import { render, staticRenderFns } from "./targetComponets.vue?vue&type=template&id=6f50fb97&scoped=true&lang=pug&"
import script from "./targetComponets.vue?vue&type=script&lang=js&"
export * from "./targetComponets.vue?vue&type=script&lang=js&"
import style0 from "./index.scss?vue&type=style&index=0&id=6f50fb97&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f50fb97",
  null
  
)

export default component.exports